import type { BranchPermission } from '../../../shell/session/store/sessionTypes';

function parseActions(raw: unknown): Record<string, boolean> | undefined {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return undefined;
  const out: Record<string, boolean> = {};
  for (const [key, value] of Object.entries(raw as Record<string, unknown>)) {
    if (value === true || value === 'true') out[key] = true;
    else if (value === false || value === 'false') out[key] = false;
  }
  return out;
}

export function serializeBranchPermissions(permissions: BranchPermission[]): string {
  return JSON.stringify(
    permissions.map((permission) => ({
      module: permission.module,
      canView: permission.canView,
      canEdit: permission.canEdit,
      canVoid: permission.canVoid,
      canDiscount: permission.canDiscount,
      canManageAgenda: permission.canManageAgenda,
      canViewOthers: permission.canViewOthers,
      actions: permission.actions ?? {},
    }))
  );
}

export function parseBranchPermissionsJson(json: string | null | undefined): BranchPermission[] | null {
  if (!json?.trim()) return null;
  try {
    const parsed = JSON.parse(json) as unknown;
    if (!Array.isArray(parsed)) return null;
    const permissions: BranchPermission[] = [];
    for (const row of parsed) {
      if (!row || typeof row !== 'object') continue;
      const module = (row as { module?: unknown }).module;
      if (typeof module !== 'string') continue;
      const actions = parseActions((row as { actions?: unknown }).actions);
      permissions.push({
        module: module as BranchPermission['module'],
        canView: Boolean((row as { canView?: unknown }).canView),
        canEdit: Boolean((row as { canEdit?: unknown }).canEdit),
        canVoid:
          (row as { canVoid?: unknown }).canVoid == null
            ? undefined
            : Boolean((row as { canVoid?: unknown }).canVoid),
        canDiscount:
          (row as { canDiscount?: unknown }).canDiscount == null
            ? undefined
            : Boolean((row as { canDiscount?: unknown }).canDiscount),
        canManageAgenda:
          (row as { canManageAgenda?: unknown }).canManageAgenda == null
            ? undefined
            : Boolean((row as { canManageAgenda?: unknown }).canManageAgenda),
        canViewOthers:
          (row as { canViewOthers?: unknown }).canViewOthers == null
            ? undefined
            : Boolean((row as { canViewOthers?: unknown }).canViewOthers),
        actions,
      });
    }
    return permissions.length > 0 ? permissions : null;
  } catch {
    return null;
  }
}
